import { LoadingIcon, useLocalTranslation } from '@jove-frontend/uikit';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function LoadingScreen(_ref) {
  var text = _ref.text,
      className = _ref.className;

  var _useLocalTranslation = useLocalTranslation(),
      $t = _useLocalTranslation.$t;

  return /*#__PURE__*/_jsxs("div", {
    className: clsx('flex h-full w-full items-center justify-center', className),
    children: [/*#__PURE__*/_jsx(LoadingIcon, {}), /*#__PURE__*/_jsxs("span", {
      className: "text-primary-black font-playfair-display text-center text-2xl font-bold",
      children: [text !== null && text !== void 0 ? text : 'Loading', /*#__PURE__*/_jsx("span", {
        className: "animate-blink",
        children: "."
      }), /*#__PURE__*/_jsx("span", {
        className: "animate-blink animation-delay-[250ms]",
        children: "."
      }), /*#__PURE__*/_jsx("span", {
        className: "animate-blink animation-delay-[500ms]",
        children: "."
      })]
    })]
  });
}